import React from 'react';
import { Container, Text, withStyles } from 'components/common';

const CurrentCashback = ({ number, padding }) => (
  <Container
    paddingHorizontal={32}
    paddingVertical={padding}
    className="w-full justify-center"
  >
    <div className="flex justify-between items-center">
      <Text className="font-title font-bold text-lg md:text-xl">
        Active cashback:
      </Text>
      <Text weight="font-light" size="text-4xl" className="text-green-primary">
        {number}%
      </Text>
    </div>
  </Container>
);

export default withStyles(CurrentCashback);
